import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

// ---- Tela da aula ----
// blocos centralizados com largura máxima em px (não encolhe com o rem
// responsivo do app) para o vídeo ficar grande e consistente.
export const ContainerAula = styled.div<{ theme: ThemeType }>`
  padding: 2rem 8rem 6rem;
  color: ${({ theme }) => theme.colors.tertiary};

  .topo-progresso,
  .player-wrapper,
  .aula-conteudo {
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
  }

  .topo-progresso {
    .contexto {
      display: block;
      text-align: center;
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 700;
      margin-top: 1rem;
    }
    .barra {
      display: flex;
      align-items: center;
      gap: 2rem;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 5rem;
      .trilho {
        flex: 1;
        height: 6px;
        border-radius: 4px;
        background-color: ${({ theme }) => theme.colors.elements};
        overflow: hidden;
        .preenchido {
          height: 100%;
          background-color: ${({ theme }) => theme.colors.secondary};
          transition: width 0.4s ease;
        }
      }
      .pct {
        min-width: 5rem;
        text-align: right;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }

  .player-wrapper {
    position: relative;
    width: 100%;
    max-width: 1040px;
    aspect-ratio: 16 / 9;
    iframe,
    .yt-player {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 4rem;
    }
    .material-frame {
      background: #fff;
    }
  }

  /* Em modo PDF o container deixa de ser 16:9 (vídeo) e ganha altura própria
     com rolagem, para a página caber inteira e não ficar gigante/cortada. */
  .player-wrapper.modo-pdf {
    aspect-ratio: auto;
    height: min(85vh, 1000px);
    .material-frame {
      position: relative;
      border-radius: 1.5rem;
      overflow: auto;
    }
  }

  .aula-conteudo {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-top: 5rem;
    gap: 5rem 4rem;
    .aula-info {
      flex: 1 1 0;
      min-width: 0;
      text-align: left;
      strong {
        display: block;
        color: ${({ theme }) => theme.colors.secondary};
        margin-bottom: 1.5rem;
      }
      .descricao {
        text-align: justify;
        white-space: pre-line;
        .link-descricao {
          color: ${({ theme }) => theme.colors.primary};
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }

  .materiais {
    flex: 0 0 100%;
    text-align: left;
    strong {
      display: block;
      margin-bottom: 2rem;
      color: ${({ theme }) => theme.colors.secondary};
    }
    .lista-materiais {
      display: flex;
      flex-wrap: wrap;
      gap: 2rem;
      .material-item {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        background-color: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.elements};
        border-radius: 3rem;
        padding: 2rem 3rem;
        color: ${({ theme }) => theme.colors.tertiary};
        text-decoration: none;
        cursor: pointer;
        font: inherit;
        &:hover {
          border-color: ${({ theme }) => theme.colors.secondary};
        }
      }
    }
  }

  .proximo-conteudo {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    flex: 0 0 auto;
    gap: 2rem;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.elements};
    border-radius: 5rem;
    padding: 2rem 2.5rem;
    cursor: pointer;
    white-space: nowrap;
    &:hover {
      border-color: ${({ theme }) => theme.colors.secondary};
    }
    .texto {
      display: flex;
      flex-direction: column;
      .rotulo {
        color: ${({ theme }) => theme.colors.placeholder};
      }
      .nome {
        font-weight: 700;
        color: ${({ theme }) => theme.colors.tertiary};
      }
    }
    .seta {
      width: 5rem;
      height: 5rem;
      min-width: 5rem;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors.secondary};
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2.4rem;
      font-weight: 700;
    }
  }

  @media (max-width: 1024px) {
    padding: 2rem 3rem 12rem;
    .aula-conteudo {
      flex-direction: column;
      .aula-info {
        flex: 0 0 auto;
        width: 100%;
      }
    }
  }

  /* mobile: o botão "próximo conteúdo" vai por último (depois do material) */
  @media (max-width: 425px) {
    .aula-conteudo {
      .aula-info {
        order: 1;
      }
      .materiais {
        order: 2;
      }
      .proximo-conteudo {
        order: 3;
      }
    }
  }
`;
